import SplitType from "split-type";
import gsap from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import Lenis from "lenis";

gsap.registerPlugin(ScrollTrigger);

export function initAnimations() {
    /* NAV MENU HOVER MAGIC */
    const menuWrapper = document.querySelector(".menu-wrapper");
    const overlay = menuWrapper.querySelector(".overlay");
    const menuLinks = menuWrapper.querySelectorAll(
        "ul.menu__list .menu__main-nav-link"
    );

    let currentActiveLink = null;

    menuLinks.forEach((link) => {
        link.addEventListener("mouseenter", () => {
            const rect = link.getBoundingClientRect();
            const wrapperRect = menuWrapper.getBoundingClientRect();

            if (currentActiveLink) {
                currentActiveLink.classList.remove("overlay-active");
            }

            currentActiveLink = link;
            link.classList.add("overlay-active");

            overlay.classList.add("active");
            overlay.style.left = rect.left - wrapperRect.left + "px";
            overlay.style.top = rect.top - wrapperRect.top + "px";
            overlay.style.width = rect.width + "px";
            overlay.style.height = rect.height + "px";
        });
    });

    menuWrapper.addEventListener("mouseleave", () => {
        overlay.classList.remove("active");
        if (currentActiveLink) {
            currentActiveLink.classList.remove("overlay-active");
            currentActiveLink = null;
        }
    });

    /* COUNTUP MAGIC */
    const countupObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add(
                    entry.target.dataset.counterType + "--active"
                );
            }
        });
    });

    const allCountups = document.querySelectorAll(".countup");
    const counterTypes = ["countup-percent", "countup-plus", "countup-decimal"];

    allCountups.forEach((element, index) => {
        element.dataset.counterType = counterTypes[index];
        countupObserver.observe(element);
    });

    /* TEXT MAGIC */
    gsap.registerPlugin(ScrollTrigger);

    const colorMap = {
        "fg-black": "black",
        "fg-purple": "#6F47BA",
        "fg-purple-dark": 'var(--color-purple-dark)',
        "bg-gray-light": "rgba(204,204,204,0.16)",
    };

    function makeAccessible(el) {
        const span = document.createElement("span");
        span.setAttribute("aria-hidden", "true");
        span.innerHTML = el.innerHTML;
        el.setAttribute("aria-label", el.textContent.trim());
        el.textContent = "";
        el.appendChild(span);
        return span;
    }

    document.querySelectorAll(".reveal-section").forEach((section) => {
        const splitTypes = section.querySelectorAll(".reveal-type");
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: "top 90%",
                end: "top 20%",
                scrub: true,
                markers: false,
            },
        });

        splitTypes.forEach((el, i) => {
            const fgClass = Array.from(el.classList).find((cls) =>
                cls.startsWith("fg-")
            );
            const bgClass = Array.from(el.classList).find((cls) =>
                cls.startsWith("bg-")
            );

            const fg = colorMap[fgClass];
            const bg = colorMap[bgClass];

            if (!fg || !bg) return;

            const visibleSpan = makeAccessible(el); // wrap content in span
            const text = new SplitType(visibleSpan, {types: "words, chars"});

            tl.fromTo(
                text.chars,
                {color: bg},
                {
                    color: fg,
                    duration: 0.3,
                    stagger: 0.02,
                    ease: "none",
                },
                i === 0 ? 0 : ">0.05"
            );
        });
    });

// Standalone reveal-types outside sections
    document
        .querySelectorAll(".reveal-type:not(.reveal-section .reveal-type)")
        .forEach((el) => {
            const fgClass = Array.from(el.classList).find((cls) =>
                cls.startsWith("fg-")
            );
            const bgClass = Array.from(el.classList).find((cls) =>
                cls.startsWith("bg-")
            );

            const fg = colorMap[fgClass];
            const bg = colorMap[bgClass];

            if (!fg || !bg) return;

            const visibleSpan = makeAccessible(el); // wrap content in span
            const text = new SplitType(visibleSpan, {types: "words, chars"});

            gsap.fromTo(
                text.chars,
                {color: bg},
                {
                    color: fg,
                    duration: 0.3,
                    stagger: 0.02,
                    scrollTrigger: {
                        trigger: el,
                        start: "top 80%",
                        end: "top 20%",
                        scrub: true,
                        markers: false,
                    },
                }
            );
        });


    // FADE IN TEXT MAGIC
    document.addEventListener("DOMContentLoaded", () => {
        const elements = document.querySelectorAll(".fade-in-up");

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("visible");
                    observer.unobserve(entry.target); // optional: only once
                }
            });
        }, {threshold: 0.1});

        elements.forEach((el) => observer.observe(el));
    });


    const lenis = new Lenis();
    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add((time) => {
        lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);

    // Gallery: Ensure tall (portrait) images never exceed a square shape
    document.querySelectorAll(".gallery-item img").forEach((el) => {
        if (el.naturalHeight > el.naturalWidth) {
            el.style.aspectRatio = "1 / 1";
        }
    });
}
